module.exports = __webpack_public_path__ + "static/media/vectorAcert.52b18402.svg";